// useKardexXL - Sprint 44 Fase 3 Vista 5.
// Hook de kardex por producto: carga /productos/:id/kardex, expone
// {producto, movs, loading, err, valorizacion}. Solo lectura.
import { useEffect, useState } from 'react';
import apiClient from '../../../api/apiClient';

export default function useKardexXL(productoId) {
  const [producto, setProducto] = useState(null);
  const [movs, setMovs]         = useState([]);
  const [loading, setLoading]   = useState(true);
  const [err, setErr]           = useState(null);

  useEffect(() => {
    if (!productoId) { setLoading(false); return undefined; }
    let alive = true;
    setLoading(true);
    setErr(null);
    apiClient.get('/productos/' + productoId + '/kardex')
      .then((r) => {
        if (!alive) return;
        const d = (r && r.data) || {};
        setProducto(d.producto || null);
        setMovs(Array.isArray(d.movimientos) ? d.movimientos : []);
      })
      .catch((e) => {
        if (alive) {
          setErr((e && e.message) || 'Error al cargar kardex');
          setProducto(null);
          setMovs([]);
        }
      })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [productoId]);

  const stock = Number((producto && producto.stock) || 0);
  const cp = Number((producto && producto.costo_promedio) || 0);
  const valorizacion = stock * cp;

  return {
    producto, movs, loading, err, valorizacion,
  };
}
